<template>
    <div class="stress-selector">
        <div class="stress-selector__inner">
            <ul v-if="symbols.length" class="stress-selector__word">
                <li
                    v-for="(symbol, index) in symbols"
                    :key="index"
                    class="stress-selector__char"
                    :class="{ 'is-active': value == index + 1 }"
                    @click="setStress(index)"
                >
                    {{ symbol }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SsmlStressControl',
    props: {
        nodes: {
            type: Array,
            required: true,
            validator: value => {
                return value.length === 1;
            }
        },
        value: {
            type: [String, Number],
            default: undefined
        },
        speaker: {
            type: String,
            required: true
        }
    },
    computed: {
        isTag() {
            return this.nodes[0].type === 'tag';
        },
        hasStress() {
            return !!this.value;
        },
        symbols() {
            const target = this.isTag ? this.nodes[0].children[0].source : this.nodes[0].source;

            return target.split('');
        },
        //
        speakerObject() {
            return (
                this.$store.state.settings.speakers.find(
                    speaker => speaker.slug === this.speaker
                ) || {}
            );
        }
    },
    created() {
        const [node] = this.nodes;
        const {
            extra_params: { accent_symbol: symbol = null, accent_side = 'before' } = {}
        } = this.speakerObject;

        const isBefore = accent_side === 'before';

        if (!symbol) return;

        const regexp = new RegExp(symbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');

        if (node.text !== node.source && node.type === 'word' && node.source.match(regexp)) {
            const index = node.source.indexOf(symbol);

            node.source = node.source.replace(regexp, '');

            this.$parent.wrapNodes({
                attributes: {
                    to: isBefore ? index + 1 : index
                },
                type: 'tag',
                name: 'speechki-accent'
            });
        }
    },
    methods: {
        setStress(index) {
            if (this.value === index + 1) {
                this.$emit('update', null);
                return;
            }

            this.$emit('update', index + 1);
        }
    }
};
</script>

<style lang="scss" src="./SsmlStressControl.scss"></style>
